import { get, post, getInfo, postInfo } from '@/utils/apiBase.js';

// cp订单管理
export const getOrderManager = (option) => {
  return get('/apis/mdcporder/order/manager', option);
};

// cp订单详情
export const getOrderInfo = (option) => {
  return get('/apis/mdcporder/order/info', option);
};

// cp订单数据统计
export const getOrderStatistics = (option) => {
  return get('/apis/mdcporder/order/statistics', option);
};

// cp订单下载
export const getOrderManager_download = (option) => {
  return get('/apis/mdcporder/order/manager_download', option);
};

// 检测cp订单下载
export const getOrderQuery_manager_download = (option) => {
  return get('/apis/mdcporder/order/query_manager_download', option);
};
// 获取在线回报档列表
export const getSuccinctRewardList = (option) => {
  return get('/apis/project/cp/get_succinct_reward_list', option);
};
// 帮改地址
export const postModify_address = (option) => {
  return post('/apis/mdcporder/order/modify_address', option);
};
// 获取省市区
export const getAddressData = (option) => {
  return get('/apis/address/get_address_data', option);
};
// 帮改地址
export const getAddressStreet = (option) => {
  return get('/apis/address/get_address_street', option);
};
// 订单发货详情
export const getOrderDeliver_info = (option) => {
  return getInfo('/apis/mdcporder/order/deliver_info', option);
};

// 帮改地址
export const orderDeliver = (option) => {
  return postInfo('/apis/mdcporder/order/deliver', option);
};

// 订单评价
export const orderZc_oc_detail = (option) => {
  return getInfo('/apis/mdcomment/zc_oc_detail', option);
};
// cp延迟收货
export const orderDelay_recv = (option) => {
  return postInfo('/apis/mdcporder/order/delay_recv', option);
};
// cp更新发货
export const orderModify_deliver = (option) => {
  return postInfo('/apis/mdcporder/order/modify_deliver', option);
};
// 回复评价
export const orderZc_oc_reply = (option) => {
  return postInfo('/apis/mdcomment/zc_oc_reply', option);
};
// 申请地址信息
export const orderApproval_address_info = (option) => {
  return getInfo('/apis/mdcporder/order/approval_address_info', option);
};
// 申请地址审核
export const orderApproval_address_audit = (option) => {
  return postInfo('/apis/mdcporder/order/approval_address_audit', option);
};
// 通用物流模板信息
export const getMdlogisticsInfos = (option) => {
  return get('/apis/mdlogistics/infos', option);
};
// 获取订单申请发货详情
export const getApplyDeliverInfo = (option) => {
  return get('/apis/mdcporder/order/get_apply_deliver_info', option);
};
export default {
  getOrderManager,
  getOrderInfo,
  getOrderStatistics,
  getOrderManager_download,
  getOrderQuery_manager_download,
  getSuccinctRewardList,
  postModify_address,
  getAddressData,
  getAddressStreet,
  getOrderDeliver_info,
  orderDeliver,
  orderZc_oc_detail,
  orderDelay_recv,
  orderModify_deliver,
  orderZc_oc_reply,
  orderApproval_address_info,
  orderApproval_address_audit,
  getMdlogisticsInfos,
  getApplyDeliverInfo
};
